@if (uiState && config && allParticipantFields) {
  <aza-rws-multi-registration-form
    [controller]="multiRegistrationSvc.controller"
    [state]="uiState"
    [allParticipantFields]="allParticipantFields"
    [subParticipantFieldIds]="config?.subparticipant_form_field_ids"
    [eventParticipant]="eventParticipant"
    [config]="config"
    [eventSettings]="eventSettings"
    [products]="products"
    [isOrganizationManager]="isOrganizationManager"
  ></aza-rws-multi-registration-form>
}
